import * as actionTypes from './actionTypes';

export const setExtracharge = (id: number, data: any) => ({
  type: actionTypes.SET_EXTRACHARGE,
  id,
  data
});

export const setExtrachargeAll = (data: any) => ({
  type: actionTypes.SET_EXTRACHARGE_ALL,
  data
});

export const setVignetteValue = (id: number, value: any) => ({
  type: actionTypes.SET_VIGNETTE_VALUE,
  id,
  value
});

export const selectExtracharge = (id:number, index: number, isActive) => ({
  type: actionTypes.SELECT_EXTRACHARGE,
  id,
  index,
  isActive
});

export const clearExtrachargeAll = () => ({
  type: actionTypes.CLEAR_EXTRACHARGE_ALL
});

export const clearExtracharge = (id: number) => ({
  type: actionTypes.CLEAR_EXTRACHARGE,
  id
});

export const clearVignetteValue = (id: number) => ({
  type: actionTypes.CLEAR_VIGNETTE_VALUE,
  id
});
